import React from 'react';
import { t } from 'i18next';
import UploadDocumentButton from '@fingo/lib/components/buttons/UploadDocumentButton';
import UploadDocumentButtonOnboarding from '@fingo/lib/components/buttons/UploadDocumentButtonOnboarding';
import DeleteDocumentButton from '@fingo/lib/components/buttons/DeleteDocumentButton';
import AmountWithIvaCell from '@fingo/lib/components/cells/AmountWithIvaCell';
import CompanyCell from '@fingo/lib/components/cells/CompanyCell';
import DateCell from '@fingo/lib/components/cells/DateCell';
import FactoringStatusCell from '@fingo/lib/components/cells/FactoringStatusCell';
import FolioCell from '@fingo/lib/components/cells/FolioCell';
import { FOLIO_CELL_CLASS_NAME } from '@fingo/lib/theme/constants/data-grid';
import { rateStatus } from '@fingo/lib/helpers/rates';

const getColumns = (
  isMobile,
  handleDelete,
) => [
  {
    field: 'folio',
    headerName: 'Folio',
    disableColumnMenu: true,
    width: isMobile ? 65 : 130,
    cellClassName: FOLIO_CELL_CLASS_NAME,
    renderCell: ({ row }) => <FolioCell invoice={row} />,
  },
  {
    field: 'folio_flex',
    headerName: 'Folio',
    disableColumnMenu: true,
    headerAlign: 'center',
    flex: 1,
    cellClassName: FOLIO_CELL_CLASS_NAME,
    renderCell: ({ row }) => <FolioCell invoice={row} alignCenter />,
  },
  {
    field: 'dteType_Code',
    headerName: t('dte'),
    sortable: true,
    disableColumnMenu: true,
    width: 86,
    valueGetter: ({ row }) => row.dteType.name,
  },
  {
    field: 'receiver_sortable',
    headerName: 'Receptor',
    disableColumnMenu: true,
    flex: 1,
    renderCell: ({ row }) => <CompanyCell company={row.receiver} />,
  },
  {
    field: 'dateIssued',
    headerName: 'Emisión',
    disableColumnMenu: true,
    width: 126,
    renderCell: ({ row }) => <DateCell date={row.dateIssued} />,
  },
  {
    field: 'amountWithIva',
    headerName: 'Monto',
    disableColumnMenu: true,
    width: isMobile ? 90 : 126,
    renderCell: ({ row }) => <AmountWithIvaCell row={row} />,
  },
  {
    field: 'preoffer_MonthlyRate',
    headerName: t('reference rate'),
    disableColumnMenu: true,
    width: isMobile ? 40 : 126,
    valueGetter: ({ row }) => rateStatus(row, 'preoffer', 'monthlyRate'),
  },
  {
    field: 'defaultRate',
    headerName: 'Mora',
    sortable: false,
    disableColumnMenu: true,
    width: isMobile ? 40 : 91,
    valueGetter: ({ row }) => rateStatus(row, 'preoffer', 'defaultRate'),
  },
  {
    field: 'factoringStatus',
    headerName: 'Estado',
    sortable: false,
    disableColumnMenu: true,
    width: 146,
    renderCell: ({ row }) => <FactoringStatusCell invoice={row} />,
  },
  {
    field: 'uploadDocuments',
    type: 'actions',
    width: 65,
    renderCell: ({ row }) => <UploadDocumentButton invoiceId={row.id} />,
  },
  {
    field: 'uploadPurchaseOrder',
    headerName: 'Orden de compra',
    type: 'actions',
    flex: 1,
    renderCell: ({ row }) => (
      <UploadDocumentButtonOnboarding
        invoiceId={row.id}
        invoiceDocuments={row.documents}
        documentType="PURCHASE_ORDER"
      />
    ),
  },
  {
    field: 'uploadInvoice',
    headerName: 'PDF de factura',
    type: 'actions',
    flex: 1,
    renderCell: ({ row }) => (
      <UploadDocumentButtonOnboarding
        invoiceId={row.id}
        invoiceDocuments={row.documents}
        documentType="PDF"
      />
    ),
  },
  {
    field: 'deleteDocument',
    headerName: 'Acción',
    type: 'actions',
    width: isMobile ? 40 : 72,
    sortable: false,
    renderCell: ({ row }) => {
      if (!handleDelete) return null;
      return (
        <DeleteDocumentButton
          invoiceId={row.id}
          handleDelete={handleDelete}
          id="available-factoring-delete-button"
        />
      );
    },
  },
];

export default getColumns;
